/** The first message of the onboarding thread, written as the person: who they are and what they do. */
const buildOnboardingLaunchPrompt = ({ name, job } = {}) => {
  const promptParts = ["I'm new to Pieve, can you help me get started?"];
  const normalizedName = String(name || '').trim();
  const normalizedJob = String(job || '').trim();

  if (normalizedName) {
    promptParts.push(`I'm ${normalizedName}.`);
  }

  if (normalizedJob) {
    promptParts.push(`My role is ${normalizedJob}.`);
  }

  return promptParts.join(' ');
};

export default buildOnboardingLaunchPrompt;
